export const getIndexCampaigns = (state) => state.indexCampaigns;
